/* global barba, barbaRouter, videojs */
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {indexAnimation} from './animation/index';
import {articleAnimation} from './animation/article';
import share from './share';
import {menu} from './components/menu';
import video from './components/video';
import helpers from './helpers';
import moreArcAnim from './animation/more-arc';
import scrollDepth from 'scroll-depth';
import analytics from './components/analytics';

$('.cookie__button').on('click', () => {
	gsap.to('.cookie', {
		autoAlpha: 0,
		onComplete() {
			$('.cookie').addClass('is-hidden');
		},
	});
});

const routes = [{
	path: '/',
	name: 'index',
},
{
	path: '/ledokolnyj-flot.html',
	name: 'ledokolnyj-flot',
},
{
	path: '/yadernaya-medicina.html',
	name: 'yadernaya-medicina',
},
{
	path: '/ekologichnost-predpriyatij.html',
	name: 'ekologichnost-predpriyatij',
},
{
	path: '/kompozitnye-materialy.html',
	name: 'kompozitnye-materialy',
},
{
	path: '/atomnaya-energetika.html',
	name: 'atomnaya-energetika',
},
];

barba.use(barbaRouter, {
	routes,
});

barba.hooks.afterLeave(({current}) => {
	const $articleMore = $('.article__more');
	const $articleMoreArcText = ScrollTrigger.getById($('.article__more-arc-text'));

	// eslint-disable-next-line no-console
	video.destroy(current.container);
	analytics.destroy();

	$('.aos-animate').removeClass('aos-animate');

	AOS.refresh();
	share.destroy();

	// hack for more arc
	if ($articleMore && $articleMore.kill) {
		$articleMore.kill(true);
	}

	if ($articleMoreArcText && $articleMoreArcText.kill) {
		$articleMore.kill(true);
	}

	if (current.namespace !== 'index') {
		$('.article').addClass('is-old');
	}
});

barba.hooks.beforeEnter(({next}) => {
	helpers.scrollTo(helpers.$html, 0);

	share.init();

	if (next.namespace !== 'index') {
		$('.article').removeClass('is-hidden');

		video.init(next.container);

		articleAnimation();
	} else {
		indexAnimation();
	}

	menu($('.article__container'));
});

barba.hooks.afterEnter(({current}) => {
	analytics.start15SecTimeout();
	analytics.init();
	scrollDepth.reset();

	if (current.route) {
		analytics.virtualHit(window.location.pathname + window.location.hash);
	}

	setTimeout(() => {
		objectFitImages();

		if (!helpers.getCookie('cookies')) {
			gsap.from('.cookie', {
				autoAlpha: 0,
				onStart() {
					$('.cookie').removeClass('is-hidden');
				},
			});

			helpers.setCookie('cookies', true, 7);
		}
	}, 1000);
});

// init Barba
barba.init({
	sync: true,
	timeout: 2000,
	transitions: [
		{
			name: 'none',
			leave(data) {
				let done = this.async();

				gsap.to(data.current.container, {
					duration: 0.4,
					autoAlpha: 0,
					onComplete: () => {
						moreArcAnim.destroy();
						done();
					},
				});
			},
			enter(data) {
				let done = this.async();
				gsap.from(data.next.container, {
					duration: 0.4,
					autoAlpha: 0,
					onComplete: done,
				});
			},
			appear() {
			},
		},
		{
			name: 'slide-enter[-index]',
			appear() {
			},
		},
	],

	views: [
		{
			namespace: 'index',
		},
		{
			namespace: 'ledokolnyj-flot',
		},
		{
			namespace: 'yadernaya-medicina',
		},
		{
			namespace: 'ekologichnost-predpriyatij',
		},
		{
			namespace: 'kompozitnye-materialy',
		},
		{
			namespace: 'atomnaya-energetika',
		},
	],
});
